import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {setInventoryItem, donateInventoryItem} from './../../actions/inventoryActions';
import {Accordion, Dimmer, Loader, Grid, Button} from 'semantic-ui-react';
import kmToMi from 'km-to-mi';
import Location from './Location';

class InventoryItem extends React.Component {

    constructor(props){
        super(props);

    }
    componentWillMount(){ }
    
    componentDidMount(){
        
    }

    render(){

        const isActive = ()=>{
            return (this.props.selected && (this.props.selected.objectID === this.props.hit.objectID) );
        }

        const getDistance = ()=>{
            if(!this.props.hit._rankingInfo || !this.props.hit._rankingInfo.geoDistance) return null;
            const distance = kmToMi(this.props.hit._rankingInfo.geoDistance / 1000);

            return (
                <div className="InventoryItem-Distance f6 c-primary-hi">
                    Drop Off &lt; {Math.ceil(distance)} miles
                </div>
            )
        }

        const renderLocations = ()=>{
            if(!this.props.selected || !this.props.selected.locations) return null;

            return (
                <div>
                    <h3 className="f4 c-primary bold">DROP OFF / POSTAL LOCATIONS</h3>
                    {
                        this.props.selected.locations.map((l, idx)=> <Location location={l} geo={this.props.selected._geoloc[idx]} />)
                    }
                </div>
                
            )
        }
        
        return (
        <Accordion styled className="InventoryItem" fluid >
            <Accordion.Title
                onClick={()=>{this.props.setInventoryItem(this.props.hit)}}
            >
                <div className="InventoryItem-header">
                    <div className="InventoryItem-logo" style={{backgroundImage : `url(${this.props.hit.logo})` }}>

                    </div>
                    <div className="InventoryItem-content">
                        <h3 className="f3 m-0 c-primary bold">{this.props.hit.name}</h3>
                        <p className={ isActive()? 'active f5 truncate c-grey'  :'f5 truncate c-greygi'}>{this.props.hit.description}</p>

                    </div>
                    <div className="InventoryItem-Count ta-r">
                        {getDistance()}
                        <span className="quantityRequired f1 c-primary bold mt-1">{this.props.hit.quantityRequired}</span>
                        <span className="f6 c-primary">NEEDED</span>
                    </div>


                </div>

                {/*<img style={{width:30,height:30}} src={this.props.hit.logo} alt=""/>*/}

            </Accordion.Title>
            <Accordion.Content active={isActive()} style={{position:'relative'}}>
                <div className="InventoryItem-mainContent">
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={8}>
                                <p className="f5 mb-2">{this.props.hit.description}</p>

                                {renderLocations()}

                                
                            </Grid.Column>
                            <Grid.Column width={8}>
                                <img src={this.props.hit.image} alt=""/>
                                <Button floated="right" onClick={this.props.donateInventoryItem} size="huge" primary>Donate</Button>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>


                </div>

                {/*<Dimmer active={this.props.loading}>*/}
                    {/*<Loader />*/}
                {/*</Dimmer>*/}

            </Accordion.Content>

        </Accordion>

        )
    }
}

InventoryItem.propTypes = {
    
}

const mapStateProps = (state) => {
    return {
        selected : state.inventory.selectedRef,
        loading : state.inventory.loading
    };
}

export default  connect(mapStateProps, { setInventoryItem, donateInventoryItem})(InventoryItem);



// WEBPACK FOOTER //
// ./src/components/common/InventoryItem.js